import React from "react";
import Card from "react-bootstrap/Card";
import ShowMoreText from "react-show-more-text";
import projImg9 from "../../assets/img/9.png";
import projectimage12 from "../../assets/img/p12.png";

const PreviousCard12 = () => {
    return (
        <Card className="CARD2" bg="dark">
              {/* <Card.Title><h2>Physics-informed neural networks for engineering applications</h2></Card.Title> */}
              <Card.Img variant="top" src={projectimage12} />

              <Card.Body>
                <Card.Text>
                  <img className="img2" src={projImg9} />{" "}
                  <p className="text7">Botond Szilágyi </p>
                  <br />
                  <p className="text8">
                    Associate Professor <br /> Department of Chemical and
                    Environmental Process Engineering, BME
                  </p>
                  {/*  <p className="text7">Supervisor:Dr. Mihály Szabó </p><br/>
               <p className="text7">Rector's delegate. Rector's Office Directorate of Education, BME </p> */}
                  {/* <img className="img2" src={projImg21}/> */}
                </Card.Text>
                <ShowMoreText lines={1}>
                  <div>
                    Differential equations are frequently utilized in chemical
                    engineering practice for process modeling and simulation
                    that allows for evaluating the performance of chemical
                    processes before the first real experiment and investment.
                    In this context, process models will have a major role in
                    the transition to cleaner and safer production, accelerating
                    the adoption of fully circular economies. Unfortunately, the
                    computational cost of these differential equations is
                    prohibitive for many applications (despite the recent
                    significant progress in information technology that includes
                    parallel, GPU, and cloud computing (Szilágyi & Nagy, 2016).
                    It was shown recently that neural networks could be used to
                    approximate the solution of differential equations
                    describing fluid mechanics (Cai et al., 2021), by
                    incorporating the differential equation into the loss
                    function. This study aims to extend the concept of
                    physics-informed neural networks to general chemical
                    engineering applications by solving representative case
                    studies for chemical and biochemical reactions and
                    separation models. This work will pave the way for spreading
                    digital solutions across all engineering fields.
                    <br />
                    <br />
                    Recommended literature:{" "}
                    <ul>
                      <li>
                        Cai, S., Mao, Z., Wang, Z., Yin, M., & Karniadakis, G.
                        E. (2021). Physics-informed neural networks (PINNs) for
                        fluid mechanics: a review.{" "}
                        <span className="text9">Acta Mechanica Sinica </span>, 37(12),
                        1727–1738.{" "}
                        <a href="https://doi.org/10.1007/s10409-021-01148-1">
                          https://doi.org/10.1007/s10409-021-01148-1
                        </a>
                      </li>{" "}
                      <li>
                        Szilágyi, B., & Nagy, Z. K. (2016). Graphical processing
                        unit (GPU) acceleration for numerical solution of
                        population balance models using high resolution finite
                        volume algorithm.
                        <span className="text9">
                          {" "}
                          Computers and Chemical Engineering{" "}
                        </span>
                        , 91, 167–181.{" "}
                        <a href="https://doi.org/10.1016/j.compchemeng.2016.03.023">
                          {" "}
                          https://doi.org/10.1016/j.compchemeng.2016.03.023
                        </a>
                      </li>
                    </ul>
                  </div>
                </ShowMoreText>
              </Card.Body>
            </Card>
    );
};

export default PreviousCard12;
